import React from "react";

export const WallClockIcon = () => {
  return (
    <svg
      id="wall-clock"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g id="Group_12234" data-name="Group 12234">
        <g id="Group_12233" data-name="Group 12233">
          <path
            id="Path_225535"
            data-name="Path 225535"
            d="M415.439,376.866a.7.7,0,0,0-.984.144c-.127.171-.264.339-.405.5a.7.7,0,1,0,1.054.931c.168-.19.329-.389.48-.592A.7.7,0,0,0,415.439,376.866Z"
            transform="translate(-399.323 -363.482)"
            fill="#dc8e1e"
          />
          <path
            id="Path_225536"
            data-name="Path 225536"
            d="M463.547,286.441a.7.7,0,0,0-.837.537c-.045.209-.1.418-.163.622a.7.7,0,1,0,1.344.415c.075-.242.14-.49.194-.738A.7.7,0,0,0,463.547,286.441Z"
            transform="translate(-446.255 -276.355)"
            fill="#dc8e1e"
          />
          <path
            id="Path_225537"
            data-name="Path 225537"
            d="M335.014,442.283c-.187.1-.38.2-.574.289a.7.7,0,1,0,.579,1.282c.231-.1.46-.22.681-.343a.7.7,0,0,0-.686-1.228Z"
            transform="translate(-322.283 -426.647)"
            fill="#dc8e1e"
          />
          <path
            id="Path_225538"
            data-name="Path 225538"
            d="M159.588,76.7v5.334l-2.578,2.578a.7.7,0,0,0,.994.994l2.784-2.784a.7.7,0,0,0,.206-.5V76.7a.7.7,0,0,0-1.406,0Z"
            transform="translate(-151.291 -73.328)"
            fill="#dc8e1e"
          />
          <path
            id="Path_225539"
            data-name="Path 225539"
            d="M17.3,1.512a.7.7,0,0,0-.7.7V4.167A9,9,0,1,0,9,18h.035c.253,0,.509-.011.761-.032a.7.7,0,1,0-.117-1.4c-.212.018-.429.027-.643.027H9A7.594,7.594,0,1,1,15.537,5.133H13.6a.7.7,0,0,0,0,1.406H15.75a2.236,2.236,0,0,0,1.17-.329.7.7,0,0,0,.063-.04A2.249,2.249,0,0,0,18,4.289V2.215A.7.7,0,0,0,17.3,1.512Z"
            fill="#dc8e1e"
          />
        </g>
      </g>
    </svg>
  );
};
